import saleRoutes from './routes'

/* @ngInject */
const saleRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(saleRoutes.index.path, {
      url: saleRoutes.index.url,
      redirectTo: saleRoutes.consult.path,
      template: require('./templates/index.html'),
      controller: 'saleCtrl',
    })
    .state(saleRoutes.new.path, {
      url: saleRoutes.new.url,
      template: require('./templates/new.html'),
    })
    .state(saleRoutes.consult.path, {
      url: saleRoutes.consult.url,
      template: require('./templates/consult.html'),
    })
    .state(saleRoutes.details.path, {
      url: saleRoutes.details.url,
      template: require('./templates/details.html'),
    })
    .state(saleRoutes.edit.path, {
      url: saleRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(saleRoutes.axletrees.path, {
      url: saleRoutes.axletrees.url,
      template: require('./templates/editAxletrees.html'),
    })
    .state(saleRoutes.pieces.path, {
      url: saleRoutes.pieces.url,
      template: require('./templates/editPieces.html'),
    })
    .state(saleRoutes.steriles.path, {
      url: saleRoutes.steriles.url,
      template: require('./templates/editSteriles.html'),
    })
    .state(saleRoutes.generateBLWagons.path, {
      url: saleRoutes.generateBLWagons.url,
      template: require('./templates/generateBLWagons.html'),
    })
    .state(saleRoutes.generateBLEssieux.path, {
      url: saleRoutes.generateBLEssieux.url,
      template: require('./templates/generateBLEssieux.html'),
    })
}

export default saleRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/sale/sale.routes.js